<template>
    <div class="flex-1 max-w-md pr-4">
        <NewPasswordForm v-if="store.isPasswordRecoveryConfirm" />
        <ResetForm v-else />
    </div>
</template>

<script setup lang="ts">
import NewPasswordForm from '@/components/NewPasswordForm.vue'
import ResetForm from '../components/ResetForm.vue'
import { useAuthStore } from '@/stores/authStore';

const store = useAuthStore()
</script>